// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__38BhD","inner":"Footer_inner__2vx-b","nextIcon":"Footer_nextIcon__3SFTR","innerLeft":"Footer_innerLeft__1KihJ"};